import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import hpeBgImg from "../assets/hpe-bg.jpg";
import {
  callApiPostJson,
  callApiText,
  injectStyle,
  release,
  logAccess,
  callApiGetJson,
  APIServerURL,
  callApiValidatePort,
  envKey,
  validateEmail,
  validatePassword
} from "./GlobalSettings";
import { showToast } from "../common/UtilityHelper";

class CustomerRegistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
        cust_email: undefined,
       // cust_email_missing:false,
        cust_firstName: undefined,
       // cust_firstName_missing: false,
        cust_lastName: undefined,
      //  cust_lastName_missing: false,
        cust_Pwd: undefined,
      //  cust_Pwd_missing:false,
        cust_confirmPwd: undefined,
      //  cust_PwdNotSame: false,
        newCustomerRegister: {"UserID": null, "EmailAddress": null, "FirstName": null, "LastName": null, "Password": null, "ConfirmPassword": null, "UserType": "3" },
        enableRegister: false,
        reg_info_missing: false,
        reg_missing_msg: undefined
    }

    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
    this._handleFNameChange = this._handleFNameChange.bind(this);
    this._handleLNameChange = this._handleLNameChange.bind(this);
    this._handleEmailChange = this._handleEmailChange.bind(this);
    this._handlePwdChange = this._handlePwdChange.bind(this);
    this._handleConfirmPwdChange = this._handleConfirmPwdChange.bind(this);
  }

  componentDidMount() {
    this.state = {
      showLoadingPage: false,
    };
  }

  _HPEOnBackClick() {
    this.props.history.goBack();
  }

  _handleFNameChange(event){
    console.log("FirstName value is ", event.target.value);
   /*  var newCustomerObject = this.state.newCustomerRegister;
    newCustomerObject.FirstName = event.target.value;
    this.setState({newCustomerRegister : newCustomerObject}); */


    if(event.target.value && event.target.value.length > 0) {
      this.setState({cust_firstName: event.target.value});
    }
    /* else {
        this.setState({reg_info_missing: true, reg_missing_msg: "First Name is required"});       
    } */

       /*  if(this.state.newCustomerRegister.EmailAddress && this.state.newCustomerRegister.FirstName &&
          this.state.newCustomerRegister.LastName && this.state.newCustomerRegister.Password &&
          this.state.newCustomerRegister.ConfirmPassword)
          this.setState({enableRegister: true});
      else this.setState({enableRegister: false});
 */
  }

  _handleLNameChange(event){
    console.log("Last Name value is ", event.target.value);
    /* var newCustomerObject = this.state.newCustomerRegister;
    newCustomerObject.LastName = event.target.value;

    this.setState({newCustomerRegister : newCustomerObject}); */


    if(event.target.value && event.target.value.length > 0) {
      
      this.setState({cust_lastName: event.target.value});
    }
    /* else {
        this.setState({reg_info_missing: true, reg_missing_msg: "Last Name is required"});
    } */

/*         if(this.state.newCustomerRegister.EmailAddress && this.state.newCustomerRegister.FirstName &&
          this.state.newCustomerRegister.LastName && this.state.newCustomerRegister.Password &&
          this.state.newCustomerRegister.ConfirmPassword)
          this.setState({enableRegister: true});
      else this.setState({enableRegister: false}); */
  }

  _handleEmailChange(event){
    console.log("email value is ", event.target.value);
   /*  var newCustomerObject = this.state.newCustomerRegister;
    newCustomerObject.EmailAddress = event.target.value;
    newCustomerObject.UserID = event.target.value;
    this.setState({newCustomerRegister : newCustomerObject});
 */
    if(validateEmail(event.target.value))
    {
      this.setState({cust_email: event.target.value});
    }
   /*  else {
        this.setState({reg_info_missing: true, reg_missing_msg: "Invalid email address" });
    } */

/*         if(this.state.newCustomerRegister.EmailAddress && this.state.newCustomerRegister.FirstName &&
          this.state.newCustomerRegister.LastName && this.state.newCustomerRegister.Password &&
          this.state.newCustomerRegister.ConfirmPassword && validateEmail(event.target.value) )
          this.setState({enableRegister: true});
      else this.setState({enableRegister: false});
     */
  }

  _handlePwdChange(event){
    console.log("Pwd value is ", event.target.value);
    /* var newCustomerObject = this.state.newCustomerRegister;
    newCustomerObject.Password = event.target.value;
    this.setState({newCustomerRegister : newCustomerObject}); */


    //if(validatePassword(event.target.value)) {
      if(event.target.value && event.target.value.length > 0) {
      
      this.setState({cust_Pwd: event.target.value});
    }
   /*  else {
        this.setState({reg_info_missing: true, reg_missing_msg: "Invalid Password (Password must be min 8 chars alpha-numeria with atleast one special character)" });
    } */

/*         if(this.state.newCustomerRegister.EmailAddress && this.state.newCustomerRegister.FirstName &&
          this.state.newCustomerRegister.LastName && this.state.newCustomerRegister.Password &&
          this.state.newCustomerRegister.ConfirmPassword &&  
          validatePassword(event.target.value))
          this.setState({enableRegister: true});
      else this.setState({enableRegister: false}); */
  }

  _handleConfirmPwdChange(event){
    console.log("Confirm Pwd value is ", event.target.value);
    /* var newCustomerObject = this.state.newCustomerRegister;
    newCustomerObject.ConfirmPassword = event.target.value;
    this.setState({newCustomerRegister : newCustomerObject}); */


    if(this.state.cust_Pwd && this.state.cust_Pwd === event.target.value) {
     
      
      this.setState({cust_confirmPwd: event.target.value});
    }
    /* else {
        this.setState({reg_info_missing: true, reg_missing_msg: "Passwords must match" });
    } */

/*         if(this.state.newCustomerRegister.EmailAddress && this.state.newCustomerRegister.FirstName &&
          this.state.newCustomerRegister.LastName && this.state.newCustomerRegister.Password &&
          this.state.newCustomerRegister.ConfirmPassword && 
          this.state.newCustomerRegister.Password === this.state.newCustomerRegister.ConfirmPassword)
          this.setState({enableRegister: true});
      else this.setState({enableRegister: false}); */
  }


  handleRegistrationPageSubmit = () => {
    console.log("Register");
    var toGo = false;
    var newObj = this.state.newCustomerRegister;

    newObj.FirstName = this.state.cust_firstName;
    newObj.LastName = this.state.cust_lastName;
    newObj.EmailAddress = validateEmail(this.state.cust_email) ? this.state.cust_email : "Invalid email";
    newObj.Password = this.state.cust_Pwd;
    newObj.ConfirmPassword = this.state.cust_confirmPwd;
    newObj.UserID = this.state.cust_email;

    console.log("Reg Obj is ", newObj);
    this.setState({newCustomerRegister: newObj});


    if(this.state.cust_firstName && this.state.cust_lastName && this.state.cust_Pwd && this.state.cust_confirmPwd && this.state.cust_email){
      if(this.state.cust_Pwd === this.state.cust_confirmPwd &&  validateEmail(this.state.cust_email)){
        //console.log("state reg obj is", this.state.newCustomerRegister);
      this.props.registerCallback(this.state.newCustomerRegister);


    }

  }
}

  render() {

    var custFName = this.state.cust_firstName;
    var custLName = this.state.cust_lastName;
    var custEmail = this.state.cust_email;
    var CustPwd = this.state.cust_Pwd;
    var custPwdConfirm = this.state.cust_confirmPwd;

    var toDisable = true;

/*     if(this.state.reg_info_missing && this.state.reg_missing_msg){
      showToast({
        message: this.state.reg_missing_msg,
        intent: "danger",
      });
    } */

    if(this.state.cust_firstName && this.state.cust_lastName && this.state.cust_Pwd && this.state.cust_confirmPwd && this.state.cust_email){
      if(this.state.cust_Pwd === this.state.cust_confirmPwd &&  validateEmail(this.state.cust_email)){
        toDisable = false;
        //console.log("state reg obj is", this.state.newCustomerRegister);
     // this.props.registerCallback(this.state.newCustomerRegister);
    }

  }

    return (
      <Box fill="vertical" align="stretch" justify="start">
        {/* <Header
          align="center"
          direction="row"
          flex={false}
          justify="between"
          gap="medium"
          background={{ color: "blue", dark: true }}
        >
          <Button icon={<Hpe />} color="brand" />
          <Menu icon={<More />} />
        </Header> */}
        <Main
          overflow="auto"
          background={{
            image: `url(${hpeBgImg})`,
            color: "background",
            dark: true,
          }}
          flex
          align="center"
          justify="center"
        >
          <Box
            align="center"
            justify="center"
            background={{ color: "background", dark: false }}
            pad="medium"
            round="xsmall"
            gap="medium"
          >
            <Heading level="1" size="small" margin="none">
              HPE Demonstration Portal
            </Heading>
            <Paragraph margin="none">
              Use this form to register for a new HPE Passport account as Customer ! All
              fields below are required to create a new account.
            </Paragraph>
            <Box align="center" justify="center" gap="small">
              <Grid columns={[{ size: "small", count: "fit" }, "medium"]}>
                <Text>Email *</Text>
                <TextInput name="Email" value={custEmail} onChange={(event) => {this._handleEmailChange(event)}} />
              </Grid>
              <Grid columns={[{ size: "small", count: "fit" }, "medium"]}>
                <Text>First Name *</Text>
                <TextInput name="FirstName" value={custFName} onChange={(event) => {this._handleFNameChange(event)}}/>
              </Grid>
              <Grid columns={[{ size: "small", count: "fit" }, "medium"]}>
                <Text>Last Name *</Text>
                <TextInput name="LastName" value={custLName} onChange={(event) => {this._handleLNameChange(event)}}/>
              </Grid>
              <Grid columns={[{ size: "small", count: "fit" }, "medium"]}>
                <Text>Password *</Text>
                <TextInput name="Password" type="password" value={CustPwd} onChange={(event) => {this._handlePwdChange(event)}} />
              </Grid>
              <Grid columns={[{ size: "small", count: "fit" }, "medium"]}>
                <Text>Confirm Password *</Text>
                <TextInput name="ConfirmPassword" type="password" value={custPwdConfirm} onChange={(event) => {this._handleConfirmPwdChange(event)}} />
              </Grid>
            </Box>
            <Box align="center" justify="center" gap="medium" direction="row">
              <Button
                label="Back"
                primary={false}
                secondary
                onClick={this.props.hide}
              />
              <Button
                label="Register"
                primary
                disabled = {toDisable}
                onClick={this.handleRegistrationPageSubmit}
              />
            </Box>
            <Paragraph>
              For the best user experience, we recommend Chrome
            </Paragraph>
          </Box>
        </Main>
      </Box>
    );
  }
}

export default withRouter(CustomerRegistration);
